export class LoadFinOpsAwsServicesHistoricalData {
    static type = '[FINOPS][AWS][SERVICES] LoadFinOpsAwsServicesHistoricalData'
}

export class LoadDataTableAllAccountsFinOpsAwsServices {
    static type = '[FINOPS][AWS][SERVICES] LoadDataTableAllAccountsFinOpsAwsServices'
}

export class LoadFinOpsAwsServicesChartsData {
    static type = '[FINOPS][AWS][SERVICES] LoadFinOpsAwsServicesChartsData'
}

export class LoadFinOpsAwsServicesAllAccountsChartsFilteredData {
    static type = '[FINOPS][AWS][SERVICES] LoadFinOpsAwsServicesAllAccountsChartsFilteredData'
}
